export default {
	hookPrefix: 'icon',
};
